import {attendeeFetchData, attendeeDeleteData, attendeePutData} from "./index";

const agendaAPI = {
  fetchMaterials: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/agenda/materials`),
  fetchMaterial: (attendeeId, materialId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/agenda/materials/${materialId}`),
};
export default agendaAPI;